module.exports = __webpack_public_path__ + "img/facebook.5a3fb2af.svg";